import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import axios from 'axios';

import { 
  Button, 
  Dialog, 
  ListItem, 
  List, 
  //Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  Backdrop,
  //DialogContent,
  //Box,
  Card,
  CardHeader,
  //CardActions,
  CardContent,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import serverURI from 'config/URI';

import { toast } from 'react-toastify';

import { templateTypes } from 'common/datas';
import { IsNoU } from 'common/utils';


const useStyles = makeStyles(theme => ({
    root: {
      backgroundColor: theme.palette.background.default,
      height: '100%',
      //margin: theme.spacing(1),
      //padding: theme.spacing(3)
    },
    card_root: {
      //padding: theme.spacing(3)
    },
    // row: {
    //   height: '82px',
    //   display: 'flex',
    //   alignItems: 'center',
    //   '& > *': {
    //     margin: theme.spacing(1),
    //   },
    // },
    // inputs: {
    //   display: 'flex',
    //   margin: theme.spacing(1),
    // },
    content: {
      //marginTop: theme.spacing(2)
      flex: 0,
    },
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    card_header: {
      backgroundColor: theme.palette.card_header,
    },
    listitem_align: {
      //alignItems: 'center',
    },
    registerListItemTitle: {
      marginLeft: theme.spacing(2),
      width: '120px',
      //height: '100%',
      //backgroundColor: theme.palette.card_header,
      // flexDirection: "column",
      // justifyContent: "center"
    },
    registerListItemInput: {
      //marginLeft: theme.spacing(2),
      width: '360px',
      //height: '40px',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
  


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const RegAndEditCategory = (props) => {

  const classes = useStyles();

  const {
    className, 
    openDialog,
    onClickCloseDialog,
    onClickSaveDialog,
    editCategory,
    modeRegisterDlg,
    ...rest
  } = props;

  const [categoryName, setCategoryName] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState(templateTypes[0].value);
  const [categorySavePath, setCategorySavePath] = useState('');

  const [openProgress, setOpenProgress] = useState(false);


  const getCheckedCategoryInfo = (name, template, path) => {
    return axios({
      method: 'post',
      url: `${serverURI}/api/advertise/category/check`,
      data: {
        name,
        template,
        path,
      }
    });
  }

  // fetchPostInfo = async (postId) => {
  //   const post = await service.getPost(postId);
  //   console.log(post);
  //   const comments = await service.getComments(postId);
  //   console.log(comments);
  // }

  const handleCheckCategory = async (name, template, path) => {
    const res = await getCheckedCategoryInfo(name, template, path);
    //console.log(res);
    const resultCheck = res.data.checked;
    //console.log(resultCheck);
    //setDisabledEditUserId(checkeduserid);
    setOpenProgress(false);
    if (resultCheck === 0) {
      const newCategory = {
        name: categoryName,
        template: selectedTemplate,
        prev_path: !IsNoU(editCategory) ? editCategory.save_path : '',
        save_path: categorySavePath,
        modified_user: '홍길동',
        modified_at: new Date(),
        description: categoryDescription,
      };
      //console.log(newCategory);
      onClickSaveDialog(newCategory);
    }
    else if (resultCheck === 1) {
      toast(categoryName+"이/가 존재 합니다.");
    }
    else if (resultCheck === 2) {
      toast(categorySavePath+"이/가 저장경로가 존재 합니다.");
    }
  }


  useEffect(() => {
  //console.log('componentDidUpdate & selectedTemplates changed');
  
    if (editCategory === null) {
      setCategoryName('');
      setCategoryDescription('');
      setSelectedTemplate(templateTypes[0].value);
      setCategorySavePath('');
    }
    else {
      setCategoryName(editCategory.name);
      setCategoryDescription(editCategory.description);
      setSelectedTemplate(editCategory.template);
      setCategorySavePath(editCategory.save_path);
    }

  }, [editCategory]);

  return (
    <Dialog 
      fullScreen open={openDialog} 
      onClose={onClickCloseDialog} 
      TransitionComponent={Transition}
    >
    <AppBar className={classes.appBar}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" className={classes.title} color="inherit">
          카테고리
        </Typography>
        <Button color="inherit" onClick={() => {

            if (IsNoU(categoryName) || categoryName.length <= 0) {
              toast("카테고리명을 입력하세요.");
              return ;
            }

            if (IsNoU(categorySavePath) || categorySavePath.length <= 0) {
              toast("서버 저장 경로를 입력하세요.");
              return ;
            }

            setOpenProgress(true);
            if (!IsNoU(editCategory)) {
                if (categoryName === editCategory.name &&
                  categorySavePath === editCategory.save_path &&
                  selectedTemplate === editCategory.template &&
                  categoryDescription === editCategory.description) {
                    setOpenProgress(false);
                    onClickCloseDialog();
                }
                else {
                  let checkName = undefined;
                  let checkTemplate = undefined;
                  let checkPath = undefined;
                  // if (categoryName !== editCategory.name || 
                  //   selectedTemplate !== editCategory.template) {
                    checkName = categoryName;
                    checkTemplate = selectedTemplate;
                  // }
                  //if (categorySavePath !== editCategory.save_path)
                  checkPath = categorySavePath;

                  // console.log("name ->" + checkName);
                  // console.log("template ->" + checkTemplate);
                  // console.log("path ->" + checkPath);
                  handleCheckCategory(checkName, checkTemplate, checkPath);
                }
            }
            else {
              handleCheckCategory(categoryName, selectedTemplate, categorySavePath);
            }
          }}>
          저장
        </Button>
      </Toolbar>
    </AppBar>

    {/* <form className={classes.root} noValidate autoComplete="off">
      <TextField id="standard-basic" label="Standard" />
      <TextField id="filled-basic" label="Filled" variant="filled" />
      <TextField id="outlined-basic" label="Outlined" variant="outlined" />
    </form> */}

    <div className={classes.root}>

    {/* <form noValidate autoComplete="off"> */}
    <List>
      <ListItem className={classes.listitem_align}>
      <Card
        className={clsx(classes.card_root, className)}
      >
        <CardHeader
          className={classes.card_header}
          title={modeRegisterDlg ? '카테고리 등록' : '카테고리 수정'}
          subheader='*표시는 필수 항목'
        />
        <CardContent className={classes.content}>
        <List>
          <ListItem className={classes.listitem_align}>
            <TextField 
              className={classes.registerListItemInput}
              required 
              id="outlined-basic1" 
              //variant="outlined" 
              label="카테고리 이름"
              placeholder="카테고리 이름을 입력하세요..."
              fullWidth
              value={categoryName}
              onChange={event=> setCategoryName(event.target.value)}
              />
          </ListItem>
          <ListItem className={classes.listitem_align}>
            <TextField 
              className={classes.registerListItemInput}
              //required 
              id="outlined-basic2" 
              //variant="outlined" 
              label="카테고리 설명"
              placeholder="카테고리 설명을 입력하세요..."
              fullWidth
              value={categoryDescription}
              onChange={event=> setCategoryDescription(event.target.value)}
            />
          </ListItem>
          <ListItem>
            <TextField
              id="outlined-select-currency"
              className={classes.registerListItemInput}
              required 
              select
              label="탬플릿"
              value={selectedTemplate}
              onChange={e => setSelectedTemplate(e.target.value)}
              //variant="outlined"
              //margin="dense"
            >
              {templateTypes.map(template => (
                <MenuItem key={template.value} value={template.value}>
                  {template.label}
                </MenuItem>
              ))}
            </TextField>
          </ListItem>
          <ListItem>
            <TextField 
              className={classes.registerListItemInput}
              id="outlined-basic4" 
              //variant="outlined" 
              required 
              label="서버저장경로"
              placeholder="영문만 입력 가능합니다."
              value={categorySavePath}
              onChange={e => { 
                let value = e.target.value;
                let prev = value;
    //            console.log(value);
                value = value.replace(/[^A-Za-z]/ig, '');
    //            console.log(value);
                if (prev !== value) {
                  toast('영문 입력만 가능합니다.');
                }
                setCategorySavePath(value);
              }}
              //margin="dense"
              />
          </ListItem>
          </List>
        </CardContent>
        </Card>
      </ListItem>
    </List>
    {/* </form> */}

    </div>
  
    <Backdrop className={classes.backdrop} open={openProgress} /*onClick={() => setOpenProgress(false)}*/>
      <CircularProgress color="inherit" />
    </Backdrop>

  </Dialog>
  );
}

export default RegAndEditCategory;